// src/activities/anchors/LineLabel.jsx
import React from 'react';

const LineLabel = ({ label }) => {
  return <span className="line-label">{label}</span>;
};

export default LineLabel;